import React from "react";
import { v4 as uuidv4 } from 'uuid';

const QuestionImage = ({ options, callback, currentAnswer }) => {
  const answer = currentAnswer ? currentAnswer.answer : null;
  const length = options.length;

  let col = '';

  if( length === 1 ) {
    col = 'col-start-3 col-span-2 text-center pb-2';
  } else if( length === 2 ) {
    col = 'col-start-2 col-span-2 text-center pb-2';
  }
  if( length > 2 ) {
    col = 'flex flex-col justify-end items-center text-center pb-2';
  }
  const col2 = length === 2 ? 'col-start-4 col-span-2 text-center pb-2' : '';
  const grid = length === 1 ? 'grid grid-cols-6 gap-4' : length === 2 ? 'grid grid-cols-6 gap-4' : 'grid grid-cols-1 sm:grid-cols-3 gap-4 pb-20 pt-14';
  const activeCol = ' shadow-lg bg-white rounded-tl-3xl rounded-br-3xl';

  const handleClick = (e) => {
    const answer = e.target.dataset.value;
    callback(answer);
  }

  return (
    <>

      <div className={grid}>
        {options ? options.map( (item, index) => {
          return (
            <div
              key={uuidv4()}
              className={length === 2 && index === 1 ? answer === item.option ? col2+activeCol : col2 : answer === item.option ? col+activeCol : col}>
              <img 
                src={item.img} 
                onClick={handleClick} 
                className={"cursor-pointer pb-5"} 
                data-value={item.option} 
                alt={'img'}
              />
              <span className="text-base sm-text-2xl font-medium">{item.option}</span>
              {item.subtext}
            </div>
          )
        }):null}
      </div>
    </>
  );
};

export default QuestionImage;
